import { FormikRadio } from "../../../../../components/FormikFields/FormikRadio.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Events/shared/CreateEventForm/components/EventStateField.tsx
var EventStateField = ({}) => {
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(FormikRadio, {
		label: "State",
		name: "state",
		options: [
			{
				label: "Pending",
				value: "pending"
			},
			{
				label: "Active",
				value: "active"
			},
			{
				label: "Closed",
				value: "closed"
			}
		],
		subText: "Events are 'pending' until they're assigned and acknowledged by at least 1 user"
	}) });
};
//#endregion
export { EventStateField };

//# sourceMappingURL=EventStateField.js.map